export const EVENT_OPEN_ISSUE_TRANSITION_MODAL = 'open-issue-transition-modal';
